// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../helpers/_old_helpers/overlayHelperClass';
import { ErrorOverlayComponent } from './error-overlay.component';

export class ErrorOverlayClass {
  private errorPopup: OverlayHelper;
  private arrowData = { arrowDirection: 'left', arrowReference: 'start', arrowColor: 'danger' };

  private hasFocus: boolean = false;
  private errorList: Array<string> = [];

  constructor(overlay: Overlay) {
    this.errorPopup = new OverlayHelper(overlay);
  }

  public setPosition(
    connectedTo,
    positionStrategy,
    offsetX,
    offsetY,
    arrowDirection,
    arrowReference,
    arrowColor?
  ) {
    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      connectedTo,
      flexiblePositionStrategy: positionStrategy,
    };

    if (offsetX !== 0) config.offsetX = offsetX;
    if (offsetY !== 0) config.offsetY = offsetY;

    if (!arrowColor) arrowColor = 'danger';

    this.arrowData = { arrowDirection, arrowReference, arrowColor };

    this.errorPopup.setConfiguration(config);
  }

  public setErrorsWithoutBlink(errorList: Array<string>) {
    this.errorList = errorList;
    if (this.hasFocus && this.errorList && this.errorList.length > 0) {
      this.errorPopup.actualizeData('errorData', this.errorList);
    }
  }

  public setErrors(errorList: Array<string>) {
    this.errorList = errorList;
    this.checkShowPopup();
  }

  public setFocus(focus) {
    this.hasFocus = focus;
    this.checkShowPopup();
  }

  private checkShowPopup() {
    if (this.hasFocus && this.errorList && this.errorList.length > 0) {
      this.errorPopup.show(ErrorOverlayComponent);
      this.errorPopup.actualizeData('errorData', this.errorList);
      this.errorPopup.actualizeData('arrowData', this.arrowData);
    } else {
      this.errorPopup.close();
    }
  }

  public cleanErros() {
    this.errorList = [];
  }
}
